var React = require('react');

function VerbotFahrzeuge (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Sonne_2","key":0}),React.createElement("g",{"id":"Sonne_2_1_","key":1}),React.createElement("g",{"id":"Wolke_x5F_03_x5F_hell","key":2}),React.createElement("g",{"id":"Wolke_x5F_01_x5F_dunkel_2","key":3}),React.createElement("path",{"fill":"#C1121C","d":"M16,28.274c-6.434,0-11.667-5.233-11.667-11.666C4.333,10.175,9.566,4.941,16,4.941\r\n\ts11.667,5.233,11.667,11.667C27.667,23.041,22.434,28.274,16,28.274z M16,7.941c-4.779,0-8.667,3.888-8.667,8.667\r\n\tc0,4.778,3.888,8.666,8.667,8.666s8.667-3.888,8.667-8.666C24.667,11.829,20.779,7.941,16,7.941z","key":4})]);
}

VerbotFahrzeuge.displayName = "VerbotFahrzeuge";

VerbotFahrzeuge.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = VerbotFahrzeuge;

VerbotFahrzeuge.default = VerbotFahrzeuge;
